module.exports = __webpack_public_path__ + "static/img/hub-parts_256.79c097d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hub-parts_256.png
// module id = 7s91
// module chunks = 0